export const projectsData = [
  {
    id: 1,
    title: "Discord Demo",
    date: "Janvier 2021",
    languages: ["React", "Redux", "Firebase", "Material-UI"],
    infos:
      "J'ai crée cette interface pour tester mes compétences ReactJS.",
    img: "./assets/img/projet-2.jpg",
    link: "https://discord-clone-yt-cd489.web.app/",
  },
  {
    id: 2,
    title: "Gmail Démo",
    date: "Janvier 2021",
    languages: ["React", "Redux", "Firebase"],
    infos:
      "Salut, visitez et testez mon application Gmail et profitez-en pour laisser vos commentaires.",
    img: "./assets/img/projet-1.jpg",
    link: "https://clone-873c1.web.app/",
  },
  {
    id: 3,
    title: "Linkedin Démo",
    date: "Janvier 2021",
    languages: ["React", "Php", "React"],
    infos:
      "Salut, visitez et testez mon application Linkedin et donnez-moi vos commentaires.",
    img: "./assets/img/projet-3.jpg",
    link: "http://www.google.com",
  },
  {
    id: 4,
    title: "African Dev Experts",
    date: "Septembre 2019",
    languages: ["HTML", "CSS", "JavaScript"],
    infos:
      "Bienvenue sur mon ancienne application HTML-CSS.",
    img: "./assets/img/projet-4.jpg",
    link: "http://africanexperts.neocities.org",
  },
];
